import { DrawerClose, DrawerTitle, DrawerHeader } from '@/components/ui/drawer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  CreateTermineFormContent,
  CreateTermineSubmitButton,
} from '@/domain/termine/features/CreateTermin/shared';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function CreateTermineDrawer() {
  const { t } = useTranslation();

  return (
    <>
      <DrawerHeader
        className={cn(
          'sticky top-0 z-10 h-14 shrink-0',
          'border-b border-neutrals-N300 bg-neutrals-N200 py-2 px-4',
        )}>
        <DrawerTitle className="flex items-center justify-between">
          <div className="flex items-center">
            <DrawerClose asChild>
              <Button
                variant="ghost"
                size="icon"
                className="hover:bg-transparent">
                <FontAwesomeIcon
                  className="text-primary-blue-B600"
                  icon={faArrowLeft}
                  fixedWidth
                />
              </Button>
            </DrawerClose>
            <span className="text-sm text-neutrals-N800">
              {t('domain.termine.sheet.neuerTermin')}
            </span>
          </div>
          <CreateTermineSubmitButton />
        </DrawerTitle>
      </DrawerHeader>

      <div className="flex-1 overflow-y-auto overscroll-contain">
        <CreateTermineFormContent />
      </div>
    </>
  );
}
